import * as Yup from 'yup';

export const model = {
  userPhoto: {
    name: 'userPhoto',
    type: 'file',
    placeholder: 'Update avatar...',
  },
};

export const validationSchema = () => Yup.object().shape({});

export const initialValues = () => {
  return {};
};
